import { BoxProps } from 'UIKit/Box/types'
import React from 'react'
import { Trans } from 'react-i18next'
import theme from 'theme'
import { InHouseIndicator, InHouseTab, InHouseTabs } from 'views/InhouseGame/components/styled'
import { InhouseGameBetBoardTab } from 'views/InhouseGame/config/types'

const BetBoardTabs: React.FC<
  { disabled?: boolean; setTab: (tab: InhouseGameBetBoardTab) => void; tab: InhouseGameBetBoardTab } & BoxProps
> = ({ setTab, tab, disabled, ...props }) => {
  return (
    <InHouseTabs
      mb={['0', '', '', '', '20px']}
      value={tab}
      onTagChanged={(tab) => {
        if (!disabled) {
          setTab(tab)
        }
      }}
      backgroundBlurColor={theme.colors.background}
      indicator={<InHouseIndicator />}
      $disabled={disabled}
      {...props}
    >
      <InHouseTab value={InhouseGameBetBoardTab.Manual} $active={tab === InhouseGameBetBoardTab.Manual}>
        <Trans>Manual</Trans>
      </InHouseTab>
      <InHouseTab value={InhouseGameBetBoardTab.Auto} $active={tab === InhouseGameBetBoardTab.Auto}>
        <Trans>Auto</Trans>
      </InHouseTab>
    </InHouseTabs>
  )
}

export default BetBoardTabs
